import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConsultationInfoService } from 'src/app/services/StoreService/ConsultationInfoService/consultation-info-service.service';
import { ConsultationService } from 'src/app/services/ConsultationService/consultation-service.service';
import { SessionService } from 'src/app/services/StoreService/SessionService/session.service';
import { Router } from '@angular/router';
import { LogoutService } from 'src/app/services/LogoutService/logout-service.service';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-monthly-consultation',
  templateUrl: './monthly-consultation.component.html',
  styleUrls: ['./monthly-consultation.component.scss']
})
export class MonthlyConsultationComponent implements OnInit, OnDestroy {

  displayedColumns: string[] = ['fecha', 'tipo-documento', 'crm', 'estado', 'total'];

  yearAndMonthSelected = null;

  graphData: any;

  starDate = null;
  endDate = null;

  pageLoader = true;
  errorMessage = false;

  channel: string;

  observable: Subscription;
  storeSubscription: Subscription;

  monthName: string;

  constructor(
    private consultationInfoService: ConsultationInfoService,
    private consultationService: ConsultationService,
    private logoutService: LogoutService,
    private router: Router,
    private store: Store<{ channel: string }>
  ) {
    this.yearAndMonthSelected = this.consultationInfoService.getYearAndMonth();
    this.storeSubscription = this.store.subscribe(state => {
      this.channel = state.channel;
      if (this.yearAndMonthSelected.length > 0) {
        this.request();
      } else {
        this.router.navigate(["/pv/monthly-weekly-consultation"]);
      }
    })
  }

  total = 0;
  pageSizeOptions: number[] = [5, 10, 15, 20];
  pageSize: number = 5;
  lowValue: number = 0;
  highValue: number = 5;

  dataGraph: any;

  data: any = null;

  ngOnInit(): void {}

  ngOnDestroy(): void {
    if (this.observable) {
      this.observable.unsubscribe();
    }

    if (this.storeSubscription) {
      this.storeSubscription.unsubscribe();
    }
  }

  request() {
    this.pageLoader = true;
    this.errorMessage = false;
    const channelToLowerCase = this.channel.toLowerCase();

    if (this.channel == "CNP" || this.channel == "WHATSAPP") {
      this.observable = this.consultationService.monthlyConsultation(channelToLowerCase, this.yearAndMonthSelected[0], this.yearAndMonthSelected[1])
        .subscribe(response => {
          if (response != null) {
            this.monthName = this.getMonthName(this.yearAndMonthSelected[1]);
            this.data = response;
            this.total = this.data.length;
            this.dataGraph = ["total", this.monthName];
            for (let i = 0; i < this.data.length; i++) {
              this.dataGraph.push(this.data[i].total)
            }
            this.pageLoader = false;
          }
        }, error => {
          if (error.status == 401) {
            this.logoutService.logout();
          };
          this.pageLoader = false;
          this.errorMessage = true;
        })
    } else if (this.channel == "CP") {
      this.observable = this.consultationService.monthlyConsultation_CP(this.yearAndMonthSelected[0], this.yearAndMonthSelected[1])
        .subscribe(response => {
          if (response != null) {
            this.monthName = this.getMonthName(this.yearAndMonthSelected[1]);
            this.data = response;
            this.total = this.data.length;
            this.dataGraph = [this.monthName, 0];
            for (let i = 0; i < this.data.length; i++) {
              this.dataGraph.push(this.data[i].total)
            }
            this.pageLoader = false;
          }
        }, error => {
          if (error.status == 401) {
            this.logoutService.logout();
          };

          this.pageLoader = false;
          this.errorMessage = true;
        })
    }
  }

  tryAgain() {
    this.request();
  }

  getMonthName(month) {
    switch (month) {
      case "01":
        return "Enero";
      case "02":
        return "Febrero";
      case "03":
        return "Marzo";
      case "04":
        return "Abril";
      case "05":
        return "Mayo";
      case "06":
        return "Junio";
      case "07":
        return "Julio";
      case "08":
        return "Agosto";
      case "09":
        return "Septiembre";
      case 10:
        return "Octubre";
      case 11:
        return "Noviembre";
      case 12:
        return "Diciembre";
      default:
        return "";
    }
  }

  getPaginatorData(event) {
    this.lowValue = event.pageIndex * event.pageSize;
    this.highValue = this.lowValue + event.pageSize;
    return event;
  }

}
